module.exports = __webpack_public_path__ + "img/blueprint-blue.737b9fb6.jpg";